import React, { Component } from 'react';
import Path from "../../../assets/img/ic-path.svg";
import PlayActive from "../../../assets/img/ic-playlist-play-active.svg";
import PlayListVideo from "../../../assets/img/ic-playlist-video.svg";
import PlayListLink from "../../../assets/img/ic-playlist-link.svg";
import PlayListFile from "../../../assets/img/ic-playlist-file-attach.svg";
import Info from "../../../assets/img/ic-info.svg";
import PlayList from "../../../assets/img/ic-playlist.svg"
import Trash from "../../../assets/img/ic-delete.svg"
import InfoModal from "../modal/info"
import { dataService } from "../../../services/dataService";
import Util from "../../../utils/utils"
import * as config from "../../../config"
import AddToPlayList from "../modal/addToPlayList";
import DeleteModal from "../modal/delete";
import axios from "axios";
import { Redirect } from "react-router-dom";

class CourseTable extends Component
{

	constructor ( props )
	{
		super( props );
		this.props = props;

		this.state = {
			infoShow : false,
			playListShow : false,
			deleteShow : false,
			item_id : -1,
			item_state : 0,
			item_type : 0,
			item_list : this.props.itemList
		};

		this.showInfoModal = this.showInfoModal.bind( this );
		this.hideInfoModal = this.hideInfoModal.bind( this );

		this.showPlayListModal = this.showPlayListModal.bind( this );
		this.hidePlayListModal = this.hidePlayListModal.bind( this );

		this.showDeleteModal = this.showDeleteModal.bind( this );
		this.hideDeleteModal = this.hideDeleteModal.bind( this );

	}

	sendLinkLog = async ( item_id ) =>
	{
		const token = "Bearer " + Util.getSession( "token" );

		await axios.post( config.api_url + "/log/" + item_id, {}, {
			timeout : 30000,
			headers : {
				'Content-Type' : 'application/x-www-form-urlencoded',
				'Authorization' : token,
			}
		} );
	};

	handleItemClick = ( item, key ) =>
	{
		switch ( item.data_type )
		{
			case "0":
				// let newList = this.state.item_list;
				//
				// if ( item.item_state === 0 )
				// {
				// 	newList[key].item_state = 1;

				dataService.setData( {
					"name" : item.title,
					"currentTime" : 0,
					"item_id" : item.id,
					"item_type" : 0,
					"url" : config.server_file_url + Util.encodeJwt( {
						"item_id" : item.id,
						"exp" : parseInt( Date.now() / 1000 ) + ( 12 * 60 * 60 )
					} )
				} );

				// }
				// else
				// {
				// 	newList[key].item_state = 0;
				//
				// 	dataService.setData( {
				// 		"action" : "edit",
				// 		"isPlaying" : true,
				// 	} );
				// }

				// this.setState( ( oldState ) => ( { ...oldState, item_list : newList } ) );

				break;
			//Video
			case "1":
				let url = config.server_file_url + Util.encodeJwt( {
					"item_id" : item.id,
					"exp" : parseInt( Date.now() / 1000 ) + ( 12 * 60 * 60 )
				} );

				dataService.setData( {
					"name" : item.title,
					"currentTime" : 0,
					"item_id" : item.id,
					"item_type" : 1,
					"url" : url,
					"videoJsOptions" : {
						autoplay : true,
						controls : false,
						responsive : false,
						isFullscreen : false,
						fluid : false,
						playbackRates: [1, 1.25, 1.5, 1.75, 2],
						fill : false,
						sources : [ {
							src : url,
							type : 'video/mp4'
						} ]
					}
				} );
				break;
			//Link
			case "2":
				this.sendLinkLog( item.id ).then( r =>
				{
					let win = window.open( item.data_link, '_blank' );
					if ( win )
					{
						win.focus();
					}
					else
					{
						alert( 'لطفا دسترسی باز شدن پنجره جدید را صادر کنید.' );
					}
				} );

				break;
			//File
			case "3":
				this.sendLinkLog( item.id ).then( r =>
				{
					let win = window.open( item.data, '_blank' );
					if ( win )
					{
						win.focus();
					}
					else
					{
						alert( 'لطفا دسترسی باز شدن پنجره جدید را صادر کنیدو' );
					}
				} );

				break;
		}

	};

	renderItems = () =>
	{
		let item_list = this.state.item_list;

		item_list.forEach( ( item, key ) =>
		{
			if ( !item.item_state )
			{
				this.state.item_list[key].item_state = 0;
			}
		} );

		return item_list.map( ( item, key ) => (
			<tr key={key}>
				<td className="table-row-icon td" onClick={() => this.handleItemClick( item, key )}>
					{/*{*/}
					{/*	item.item_state === 1 && item.data_type === "0" && <img src={Pause} alt=""/>*/}
					{/*}*/}
					{/*{*/}
					{/*	item.item_state === 0 &&*/}
						<img src={item.data_type === "4" ? Path : ( item.data_type === "0" ? PlayActive : ( item.data_type === "1" ? PlayListVideo : ( item.data_type === "2" ? PlayListLink : ( item.data_type === "3" ? PlayListFile : Path ) ) ) )} alt=""/>
					{/*}*/}

				</td>
				<td className="table-row-time td">{item.data_time && new Date( item.data_time * 1000 ).toISOString().substr( 11, 8 )}</td>
				<td className="table-row-name td">
					{item.title}
					<img className="float-left" src={Info} alt="" onClick={
						() =>
							this.showInfoModal( item.description, item.tags )
					}/>
				</td>
				<td className="table-row-playlist td">
					{
						this.props.type === "course" && <img src={PlayList} alt="" onClick={
							() =>
								this.showPlayListModal( item.id )
						}/>
					}
					{
						this.props.type === "playlist" && <img src={Trash} alt="" onClick={
							() =>
								this.showDeleteModal( item.id, item.title )
						}/>
					}
				</td>
			</tr>
		) );
	};

	showPlayListModal = ( item_id ) =>
	{
		this.setState( ( oldState ) => ( {
			...oldState,
			playListShow : true,
			playList : this.props.playList,
			item_id : item_id
		} ) );
	};

	hidePlayListModal = () =>
	{
		this.setState( ( oldState ) => ( { ...oldState, playListShow : false } ) );
	};

	showInfoModal = ( description, tags ) =>
	{
		this.setState( ( oldState ) => ( { ...oldState, infoShow : true, description : description, tags : tags } ) );
	};

	hideInfoModal = () =>
	{
		this.setState( ( oldstate ) => ( { ...oldstate, infoShow : false } ) );
	};

	showDeleteModal = ( item_id, message ) =>
	{
		this.setState( ( oldState ) => ( {
			...oldState,
			deleteShow : true,
			item_id : item_id,
			delete_model_message : message
		} ) );
	};

	hideDeleteModal = () =>
	{
		this.setState( ( oldState ) => ( { ...oldState, deleteShow : false } ) );
	};

	submitDelete = async () =>
	{
		const token = "Bearer " + Util.getSession( "token" );

		let bodyFormData = new FormData();

		bodyFormData.append( 'playlist_id', this.props.playlist_id );
		bodyFormData.append( 'item_id', this.state.item_id );
		//
		let response = await axios.post( config.api_url + "/playlist/delete_item", bodyFormData, {
			timeout : 30000,
			headers : {
				'Content-Type' : 'application/x-www-form-urlencoded',
				'Authorization' : token,
			}
		} );

		if ( response.data.status )
		{
			let new_item_list = this.state.item_list.filter( ( value, index, arr ) =>
			{
				return parseInt( value.id ) !== parseInt( this.state.item_id )
			} );

			this.setState( ( oldState ) => ( { ...oldState, item_list : new_item_list } ) );

			if ( this.state.item_list.length < 1 )
			{
				this.setState( ( oldState ) => ( { ...oldState, redirect : true } ) );
			}

			this.hideDeleteModal()
		}
	};


	render ()
	{

		if ( this.state.redirect )
		{
			return <Redirect to="/playlist"/>;
		}

		return (
			<>
				{
					this.props.type === "playlist" &&
					<DeleteModal
						show={this.state.deleteShow}
						message={this.state.delete_model_message}
						handleClose={this.hideDeleteModal}
						handleDelete={this.submitDelete}
					/>
				}

				<InfoModal
					show={this.state.infoShow}
					description={this.state.description}
					tags={this.state.tags}
					handleClose={this.hideInfoModal}
				/>

				<AddToPlayList
					show={this.state.playListShow}
					handleClose={this.hidePlayListModal}
					PlayList={this.props.playList}
					itemId={this.state.item_id}
				/>
				<table className="table">
					<thead>
					<tr>
						<th className="table-row-icon"/>
						<th className="table-row-time">
							زمان
						</th>
						<th className="table-row-name">
							نام
						</th>
						<th className="table-row-playlist">
							{this.props.type === "course" && "پلی‌لیست"}
							{this.props.type === "playlist" && "حذف"}
						</th>
					</tr>
					</thead>
				</table>
				<table className="table m-0">
					<tbody>
					{this.renderItems()}
					</tbody>
				</table>
			</>
		);
	}
}

export default CourseTable;
